import * as React from 'react';

import PageComponent from '/var/lib/jenkins/workspace/ggsc-prod-dy-cjyx-web/src/pages/CrowdMarketing';

const PageComponentName = PageComponent;

export default PageComponentName;
